import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthLanding        from './AuthLanding';
import Step1Username      from './signup/Step1Username';
import Step2Birthday      from './signup/Step2Birthday';
import Step3Email         from './signup/Step3Email';
import Step4Password      from './signup/Step4Password';
import Step1Email         from './login/Step1Email';
import Step2Password      from './login/Step2Password';
import GoogleUsernameStep from './signup/GoogleUsernameStep';

export default function AuthPage() {
  const navigate = useNavigate();

  // view: 'landing' | 'signup' | 'login' | 'google-username'
  const [view,       setView]       = useState('landing');
  const [signupStep, setSignupStep] = useState(1);
  const [loginStep,  setLoginStep]  = useState(1);
  const [formData,   setFormData]   = useState({});
  const [googleUser, setGoogleUser] = useState(null);

  const merge = (partial) => setFormData(prev => ({ ...prev, ...partial }));

  const goHome = () => navigate('/');

  /* ── Landing ── */
  if (view === 'landing') {
    return (
      <AuthLanding
        onCreateAccount={() => { setView('signup'); setSignupStep(1); setFormData({}); }}
        onLogin={() => { setView('login'); setLoginStep(1); setFormData({}); }}
        onSuccess={goHome}
        onGoogleNewUser={(user) => { setGoogleUser(user); setView('google-username'); }}
      />
    );
  }

  /* ── Google new user: username only ── */
  if (view === 'google-username') {
    return (
      <GoogleUsernameStep
        googleUser={googleUser}
        onSuccess={goHome}
        onBack={() => setView('landing')}
      />
    );
  }

  /* ── Signup flow ── */
  if (view === 'signup') {
    if (signupStep === 1) return (
      <Step1Username
        data={formData}
        onNext={(d) => { merge(d); setSignupStep(2); }}
        onBack={() => setView('landing')}
        onLoginRedirect={() => { setView('login'); setLoginStep(1); }}
      />
    );
    if (signupStep === 2) return (
      <Step2Birthday
        data={formData}
        onNext={(d) => { merge(d); setSignupStep(3); }}
        onBack={() => setSignupStep(1)}
        onLoginRedirect={() => { setView('login'); setLoginStep(1); }}
      />
    );
    if (signupStep === 3) return (
      <Step3Email
        data={formData}
        onNext={(d) => { merge(d); setSignupStep(4); }}
        onBack={() => setSignupStep(2)}
        onLoginRedirect={() => { setView('login'); setLoginStep(1); }}
      />
    );
    if (signupStep === 4) return (
      <Step4Password
        data={formData}
        onBack={() => setSignupStep(3)}
        onLoginRedirect={() => { setView('login'); setLoginStep(1); }}
        onSuccess={goHome}
      />
    );
  }

  /* ── Login flow ── */
  if (view === 'login') {
    if (loginStep === 1) return (
      <Step1Email
        data={formData}
        onNext={(d) => { merge(d); setLoginStep(2); }}
        onBack={() => setView('landing')}
      />
    );
    if (loginStep === 2) return (
      <Step2Password
        data={formData}
        onBack={() => setLoginStep(1)}
        onSuccess={goHome}
      />
    );
  }

  return null;
}
